export const getSearchBxeContainerStyle = (theme) => ({
    textAlign: 'center',
    marginLeft: 'auto',
    marginRight: 'auto'
});
